import { useState } from "react";
import { SITE } from "../data/site";

export function Logo({ variant = "full", className = "h-12 w-auto" }) {
  const [failed, setFailed] = useState(false);
  const src = variant === "monogram" ? "/jif-monogram.png" : "/jif-logo-web.webp";

  if (failed) {
    return variant === "monogram" ? (
      <span className={`flex items-center justify-center ${className}`} aria-label={SITE.logoAlt} role="img">
        <span className="font-serif text-2xl font-semibold tracking-tight text-plum">JIF</span>
      </span>
    ) : (
      <span className={`flex flex-col justify-center ${className}`} aria-label={SITE.logoAlt} role="img">
        <span className="font-serif text-xl font-semibold leading-none tracking-tight text-plum">
          JIF <span className="text-gold">·</span> Jack Iannotti Flowers
        </span>
        <span className="mt-1 text-[10px] font-sans uppercase tracking-eyebrow text-sage">Coventry, RI · Since 1974</span>
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={SITE.logoAlt}
      className={className}
      onError={() => setFailed(true)}
      data-testid={variant === "monogram" ? "logo-monogram" : "logo-full"}
    />
  );
}
